import { createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../utills/store";
import { balanceApi } from "./balanceApi";

interface BalanceState {
  balanceData: any;
}

const initialState: BalanceState = {
  balanceData: {},
};

export const balanceSlice = createSlice({
  name: "balance",
  initialState,
  reducers: {
    clearBalance: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      balanceApi.endpoints.getBalanceSummary.matchFulfilled,
      (state, { payload }) => {
        state.balanceData = payload || {};
      }
    );
  },
});

export default balanceSlice.reducer;
export const { clearBalance } = balanceSlice.actions;

export const selectBalanceData = (state: RootState) =>
  state.balance.balanceData;

export const useBalanceData = () => {
  const balanceData = useSelector(selectBalanceData);
  return useMemo(() => balanceData, [balanceData]);
};
